import { render, staticRenderFns } from "./PowerImitateRight.vue?vue&type=template&id=433a8ae4&scoped=true"
import script from "./PowerImitateRight.vue?vue&type=script&lang=js"
export * from "./PowerImitateRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a8ae4",
  null
  
)

export default component.exports